import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { isAxiosError } from "axios";
import { faqQueryKeys } from "../query-keys/faq.query-keys";
import { UpsertQuestionForm } from "../schemas";

const createFaqQuestion = async ({ data }: { data: UpsertQuestionForm }) => {
  try {
    const { data: response } = await privateAxios.post(`/faq-questions`, data);
    return response;
  } catch (error) {
    if (isAxiosError(error))
      error.message = error.response?.data.message ?? error.message;
    throw error;
  }
};

export const useCreateFaqQuestionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createFaqQuestion,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: faqQueryKeys.all,
      });
    },
  });
};

const updateFaqQuestion = async ({
  id,
  data,
}: {
  id: string;
  data: UpsertQuestionForm;
}) => {
  try {
    const { data: response } = await privateAxios.patch(
      `/faq-questions/${id}`,
      data
    );
    return response;
  } catch (error) {
    if (isAxiosError(error))
      error.message = error.response?.data.message ?? error.message;
    throw error;
  }
};

export const useUpdateFaqQuestionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateFaqQuestion,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: faqQueryKeys.all,
      });
    },
  });
};

const deleteFaqQuestion = async ({ id }: { id: string }) => {
  try {
    const { data: response } = await privateAxios.delete(
      `/faq-questions/${id}`
    );
    return response;
  } catch (error) {
    if (isAxiosError(error))
      error.message = error.response?.data.message ?? error.message;
    throw error;
  }
};

export const useDeleteFaqQuestionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteFaqQuestion,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: faqQueryKeys.all,
      });
    },
  });
};
